import {ChangeDetectionStrategy, ChangeDetectorRef, Component,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FormFieldGroupConfig} from "../../../../../model/api/form-field-group-config";
import {CcBaseComponent} from "../../../../../crystal-elements/cc-base.component";
import {FormFieldConfig} from "../../../../../model/api/form-field-config";
import {Order} from "../../../../../model/clearing/order";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-clearing-order-detail',
  templateUrl: './order-detail.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderDetailComponent extends CcBaseComponent {

  transPartKey: string = 'clearing.order';

  formRecord: any;
  detailDialogVisible: boolean;

  detailFormConfig: FormFieldGroupConfig[];

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  protected initConfigs() {
    super.initConfigs();

    this.detailFormConfig = [{
      group: '',
      fields: [
        {
          field: 'clearings',
          column: 12,
          type: TYPE.RICHFIELD,
          richFieldConfig: {
            fieldId: 'column',
            fieldName: 'column',
            tableConfigs: [
              {
                field: 'state'
              },
              {
                field: 'reason'
              },
              {
                field: 'businessDate',
                mapId: record => !record.trade ? '' : record.trade.businessDate,
                type: 'DATE'
              },
              {
                field: 'clearingDate',
                mapId: record => !record.trade ? '' : record.trade.clearingDate,
                type: 'DATE'
              },
              {
                field: 'customOrderReference',
                mapId: record => !record.trade ? '' : record.trade.customOrderReference,
                width: 150
              },
              {
                field: 'clearingHouse',
                mapId: record => !record.trade ? '' : record.trade.clearingHouse
              },
              {
                field: 'exchangeCode',
                mapId: record => !record.trade ? '' : record.trade.exchangeCode,
                width: 120
              },
              {
                field: 'contractCode',
                mapId: record => !record.trade ? '' : record.trade.contractCode
              },
              {
                field: 'maturity',
                mapId: record => !record.trade ? '' : record.trade.maturity
              },
              {
                field: 'side',
                mapId: record => !record.trade ? '' : record.trade.side
              },
              {
                field: 'displayReference',
                mapId: record => !record.trade ? '' : record.trade.displayReference,
                width: 120
              },
              {
                field: 'exchangeReference',
                mapId: record => !record.trade ? '' : record.trade.exchangeReference,
                width: 120
              },
              {
                field: 'orderReference',
                mapId: record => !record.trade ? '' : record.trade.orderReference
              },
              {
                field: 'volume',
                mapId: record => !record.trade ? '' : record.trade.volume
              },
              {
                field: 'price',
                mapId: record => !record.trade ? '' : record.trade.price,
                type: 'NUMERIC'
              },
              {
                field: 'avgPrice',
                mapId: record => !record.trade ? '' : record.trade.avgPrice,
                type: 'NUMERIC'
              },
              {
                field: 'avgPriceGroupId',
                mapId: record => !record.trade ? '' : record.trade.avgPriceGroupId
              },
              {
                field: 'account',
                mapId: record => record.trade&&record.trade.account ? record.trade.account.name: ''
              },
              {
                field: 'type',
                mapId: record => !record.trade ? '' : record.trade.type
              },
              {
                field: 'strategy',
                mapId: record => !record.trade ? '' : record.trade.strategy
              },
              {
                field: 'overrideAvgPrice',
                mapId: record => !record.trade ? '' : record.trade.overrideAvgPrice,
                type: 'NUMERIC'
              },
              {
                field: 'avgPriceResidual',
                mapId: record => !record.trade ? '' : record.trade.avgPriceResidual,
                type: 'NUMERIC'
              },
              {
                field: 'avgPriceResidualGroup',
                mapId: record => !record.trade ? '' : record.trade.avgPriceResidualGroup
              },
              {
                field: 'avgPriceResidualAlloc',
                mapId: record => !record.trade ? '' : record.trade.avgPriceResidualAlloc
              },
              {
                field: 'avgRndPrice',
                mapId: record => !record.trade ? '' : record.trade.avgRndPrice,
                type: 'NUMERIC'
              },
              {
                field: 'avgPriceResidualCurrency',
                mapId: record => !record.trade ? '' : record.trade.avgPriceResidualCurrency
              },
              {
                field: 'unmatchedVolume',
                mapId: record => !record.trade ? '' : record.trade.unmatchedVolume
              },
              {
                field: 'openClose',
                mapId: record => !record.trade ? '' : record.trade.openClose
              },
              {
                field: 'callPut',
                mapId: record => !record.trade ? '' : record.trade.callPut
              },
              {
                field: 'strike',
                mapId: record => !record.trade ? '' : record.trade.strike,
                type: 'NUMERIC'
              },
              {
                field: 'giveUpBrokerCode',
                mapId: record => !record.trade ? '' : record.trade.giveUpBrokerCode
              },
              {
                field: 'giveUpMessage',
                mapId: record => !record.trade ? '' : record.trade.giveUpMessage
              },
              {
                field: 'giveUpMessage2',
                mapId: record => !record.trade ? '' : record.trade.giveupMessage2
              },
              {
                field: 'giveUpMessage3',
                mapId: record => !record.trade ? '' : record.trade.giveupMessage3
              },
              {
                field: 'giveUpAccountType',
                mapId: record => !record.trade ? '' : record.trade.giveupAccountType
              },
              {
                field: 'origineTrader',
                mapId: record => !record.origineTrader ? '' : record.trade.origineTrader
              },
              {
                field: 'trader',
                mapId: record => !record.trade ? '' : record.trade.trader
              },
              {
                field: 'tradingEnvironment',
                mapId: record => !record.trade ? '' : record.trade.tradingEnvironment
              },
              {
                field: 'clearingBroker',
                mapId: record => !record.trade ? '' : record.trade.clearingBroker
              },
              {
                field: 'creationDate',
                mapId: record => !record.trade ? '' : record.trade.creationDate,
                type: 'DATETIME'
              },
              {
                field: 'modificationDate',
                mapId: record => !record.trade ? '' : record.trade.modificationDate,
                type: 'DATETIME'
              },
              {
                field: 'executionDate',
                mapId: record => !record.trade ? '' : record.trade.executionDate,
                type: 'DATETIME'
              },
              {
                field: 'freeText1',
                mapId: record => !record.trade ? '' : record.trade.freeText1
              },
              {
                field: 'freeText2',
                mapId: record => !record.trade ? '' : record.trade.freeText2
              },
              {
                field: 'alertText',
                mapId: record => !record.trade ? '' : record.trade.alertText
              },
              {
                field: 'exchangeOrderId',
                mapId: record => record.exchangeOrderId
              },
              {
                field: 'id'
              },
              {
                field: 'tradeId',
                mapId: record => !record.trade ? '' : record.trade.id
              },
            ],
            fields: []
          }
        }]
    }, {
      group: 'detail',
      fields: [
        {
          field: 'businessDate',
          column: 2,
          type: TYPE.DATE
        },
        {
          field: 'clearingDate',
          column: 2,
          type: TYPE.DATE
        },
        {
          field: 'exchangeOrderId',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'clientOrderId',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'customOrderReference',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'clearingHouse',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'exchangeCode',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'contractCode',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'maturity',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'side',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'reference',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'volume',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'price',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'avgPrice',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'avgPriceGroupId',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'account',
          column: 2,
          type: TYPE.TEXT,
          mapValue: record => record.account ? record.account.name : ''
        },
        {
          field: 'customerName',
          column: 2,
          type: TYPE.TEXT
        },
        // {
        //   field: 'state',
        //   column: 2,
        //   type: TYPE.TEXT
        // },
        {
          field: 'state',
          column: 2,
          type: TYPE.TEXT,
          mapValue: (record) => record.clearingInfo ? record.clearingInfo.displayState : ''
        },
        {
          field: 'type',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'tradeType',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'strategy',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'overrideAvgPrice',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'avgPriceResidual',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'avgPriceResidualGroup',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'avgPriceResidualAlloc',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'avgRndPrice',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'avgPriceResidualCurrency',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'unmatchedVolume',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'openClose',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'callPut',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'strike',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'giveUpBrokerCode',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'giveUpMessage',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'giveUpMessage2',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'giveUpMessage3',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'giveUpAccountType',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'source',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'operator',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'trader',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'submittingTrader',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'tradingEnvironment',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'clearingBroker',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'brokerageRateAmount',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'overrideBrokerageRateAmount',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'brokerageFee',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'overrideBrokerageFee',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'creationDate',
          column: 2,
          type: TYPE.DATETIME
        },
        {
          field: 'modificationDate',
          column: 2,
          type: TYPE.DATETIME
        },
        {
          field: 'executionDate',
          column: 2,
          type: TYPE.DATETIME
        },
        {
          field: 'comment',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'freeText1',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'freeText2',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'alertText',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'id',
          column: 2,
          type: TYPE.TEXT
        },
        {
          field: 'parentId',
          column: 2,
          type: TYPE.TEXT
        },]
    }];
  }

  public open(selectedItem: Order): void {
    this.formRecord = selectedItem;
    this.detailDialogVisible = true;
    this.cdref.detectChanges();
  }
}
